export default __webpack_public_path__ + "static/media/MoodBgLow.d7909cbb.png";